<template>
<div class="chapter">
<div class="inner_page">
<div class="cap">
<p class="image"><a id="page_xviii"></a><a id="fig2"><img alt="Image" src="images/map.png"/></a></p><a id="fig2">
<p class="figcaption">The Battle-Fields of South Carolina, 1775–1780.<br/>Edward McCrady, <i>The History of South Carolina in the Revolution, 1780–1783</i> (New York: Macmillan, 1902), ii.</p>
</a></div><a id="fig2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Fm03.vue?d92b4f68